<template>
  <span>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true" :class="[svgClassName, 'select-none']"><path d="M198,136a6,6,0,0,1-6,6H64a6,6,0,0,1,0-12H192A6,6,0,0,1,198,136Zm34-54H24a6,6,0,0,0,0,12H232a6,6,0,0,0,0-12Zm-80,96H104a6,6,0,0,0,0,12h48a6,6,0,0,0,0-12Z"></path></svg>
  </span>
</template>

<script>
  export default {
    name: "SortIcon",
    props: {
    svgClassName: {
      type: String,
      default: ""
      }
    }
  }
</script>
